import { getAppData, isAndroid, isIos } from "@/utils/helpers/utils";
import { getSafeSearchParam } from "@mohalla-tech/xss-safeguard";
import constants from "@/constants";
import { fetchGamificationDetail } from "@/api";
import { error } from "@sveltejs/kit";
import gamificationStore from "@/stores/gamificationStore";
import { get } from "svelte/store";
import { isLocalHost } from "@/utils";

export const getWidth = (arr) => {
  if (arr.length === 1) return "w-full";
  if (arr.length === 2) return "w-1/2";
  return "w-1/3";
};

export const perComplete = (curr, total) => {
  if (curr > total) {
    curr = total;
  }
  const val = total > 0 ? (curr / total) * 100 : 0;
  return val < 1 && val > 0 ? 1 : val;
};

export const removeSpace = (str) => str && str?.split(" ").join("");

/**
 * @returns {string | null}
 */

export const getCreatorId = (component = "") => {
  let creatorId = get(gamificationStore).creatorId;
  if (creatorId) {
    return creatorId;
  }

  if (isAndroid()) {
    creatorId = getAppData("creatorId");
  }
  if (isIos() || isLocalHost()) {
    creatorId = getSafeSearchParam("creatorId");
  }

  if (
    constants.TROPHIES === component &&
    (!creatorId || creatorId === "null")
  ) {
    return null;
  }

  gamificationStore.updateState({ creatorId: creatorId });

  return creatorId;
};

/**
 * @return {Promise<import("@/types/gamification.type").TTrophiesDataFetcher>}
 */
export const getTrophyData = async (fetch) => {
  let trophiesDetails;
  let apiError = false;
  if (getCreatorId(constants.TROPHIES)) {
    try {
      trophiesDetails = await fetchGamificationDetail(
        fetch,
        getCreatorId(constants.TROPHIES),
        constants.TROPHIES
      );
    } catch (e) {
      apiError = true;
      console.warn(e);
      throw error(500, {
        message: "Api error occurred",
      });
    }
  } else {
    throw error(404, {
      message: "CreatorId Not found",
    });
  }
  return { trophiesDetails, apiError };
};

export const getActiveCatogoryAndTrophyIndex = (
  trophySubType,
  trophyCategory,
  trophyLevel,
  trophiesDetails
) => {
  const activeCategoryIndex = trophiesDetails?.trophiesSection?.findIndex(
    (item) => item.title === trophyCategory
  );

  const activeTrophyIndex = trophiesDetails?.trophiesSection?.[
    activeCategoryIndex
  ]?.data.findIndex(
    (item) =>
      item.level === parseInt(trophyLevel) &&
      (item.trophySubType === trophySubType || item.title === trophySubType)
  );

  return { activeCategoryIndex, activeTrophyIndex };
};
